/* eslint-disable react-hooks/rules-of-hooks,no-unused-vars,react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Form } from "antd";
import BulkBills from "../../components/BulkBills/BulkBills";
import "./BulkBillsContainer.less";
import {
  fetchBillStatus,
  fetchBillType,
  fetchPayStatus,
  fetchRateModes,
  fetchServiceMode,
} from "../../store/slices/rtkDictionaries";
import { fetchServiceTypes } from "../../store/slices/services";
import { extendedSearchBills } from "../../store/slices/bills";
import { agreementsSearchActions } from "../../store/slices/agreementsSearch/agreementsSearch";

const BulkBillsContainer = () => {
  const dispatch = useDispatch();
  const date = moment();
  const lastDayOfPreviousMonth = moment().subtract(1, "months").endOf("month");
  const { tenantProperties } = useSelector((state) => state.tenants);
  const { bills } = useSelector((state) => state.bills);
  const [isLoadData, setIsLoadData] = useState(false);
  const [dataBills, setDataBills] = useState("");
  const [form] = Form.useForm();

  // получение BIN/INN БИН/ИНН
  const companyIdentityAttribute = tenantProperties?.companyIdentityAttribute;

  const billsSearchParams = {
    accountIds: undefined,
    billNumber: "",
    billTypeId: null,
    payStatusIds: [],
    amountFrom: "",
    amountTo: "",
    periodDate: [lastDayOfPreviousMonth, date],
    periodFrom: "",
    periodTo: "",
    fromToDate: [],
    fromDateFrom: "",
    fromDateTo: "",
    billStatusIds: [],
    paidDate: [],
    paidDateFrom: "",
    paidDateTo: "",
    amountTaxFrom: "",
    amountTaxTo: "",
    toPayDateFrom: "",
    toPayDateTo: "",
    "service.id": null,
    "service.rateModeId": null,
    "service.serviceType": [],
    "organization.fullName": "",
    "organization.property.typeAlias": companyIdentityAttribute,
    "organization.property.stringValue": undefined,
    "subscriber.externalId": undefined,
  };

  // Очистка списка accountSelect при входе и выходе
  useEffect(() => {
    dispatch(agreementsSearchActions.cleanAccounts());
    return () => dispatch(agreementsSearchActions.cleanAccounts());
  }, []);

  useEffect(() => {
    setDataBills(bills);
  }, [bills]);

  useEffect(() => {
    dispatch(fetchBillStatus());
    dispatch(fetchBillType());
    dispatch(fetchServiceTypes());
    dispatch(fetchPayStatus());
    dispatch(fetchRateModes());
    return () => {
      setIsLoadData(false);
    };
  }, []);

  const handleSearchBills = (values) => {
    setIsLoadData(true);
    dispatch(extendedSearchBills(values));
  };

  const resetSearch = () => {
    setIsLoadData(false);
    form.setFieldsValue(billsSearchParams);
    dispatch(agreementsSearchActions.cleanAccounts());
  };

  return (
    <div className="container_height">
      <BulkBills
        dataBills={dataBills}
        handleSearchBills={handleSearchBills}
        resetSearch={resetSearch}
        isLoadData={isLoadData}
        billsSearchParams={billsSearchParams}
        form={form}
        companyIdentityAttribute={companyIdentityAttribute}
      />
    </div>
  );
};
export default BulkBillsContainer;
